import React, {createRef, useState, useContext} from 'react';
import axios from "axios";
import __ from "lodash";
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import {MenuItem, Select, TablePagination, useTheme} from "@material-ui/core";

import SystemContext from "../../../SystemContext";
import MaskedText from "../../../controls/MaskedText";
import { ColumnWidth, ValidatorColumn } from "../../../blocks/ColumnHelper";
import CurrencySelector from "../../Currencies/components/CurrencySelector";
import ExchangeRateProviderSelector from "../../Currencies/components/ExchangeRateProviderSelector";
import FuelSupplierValidator from "../validators/FuelSupplierValidator";
import FuelSupplierAirportList from "./FuelSupplierAirportList";

import { useCompanies, useAddCompany, useUpdateCompany, useDeleteCompany } from "../../../services/companies";

import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import { defaultComponents } from '../../../controls/Material-Table-Components';

const apiSitePrefix = getApiSitePrefix();

const FuelSupplierList = (_props) => {
  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const validatorColumn = ValidatorColumn(FuelSupplierValidator, true);

  const props = {
    canEdit: true,
    ..._props
  }
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleAddCompany = useAddCompany();
  const handleUpdateCompany = useUpdateCompany();
  const handleDeleteCompany = useDeleteCompany();

  const queryClient = useQueryClient();
  const extraKeys = ['FUEL_SUPPLIER'];
  const companies = useCompanies({tableRef, queryClient, extraKeys});

  const contractTypes = SystemData.contractTypes;
  const pricePeriods = SystemData.pricePeriods;

  async function downloadFuelSuppliers() {

    const operatorName = __.startCase(__.toLower(process.env.REACT_APP_COMPANY)) || "Magma";
    const url = `${apiSitePrefix}/fuelsuppliers/exportToExcel`;
    const response = await axios.get(url, {
      headers: {
        //'Access-Control-Allow-Headers': ['Origin', 'X-Requested-With', 'Content-Type', 'Accept'],
        'Access-Control-Allow-Origin': '*',
      }
    });

    if (response && response.data) {
      if (response.data.status) {
        const fileName = `${operatorName} Fuel Supplier Data.xlsx`;
        let a = document.createElement('a');
        a.href = response.data.signedUrl;
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
        }, 0);
      } else {
        SystemData.openAlert(
          "Download Error",
          "The Fuel Supplier Excel file could not be downloaded due to server error: " + response.data.error
        );
      }
    }
  }

  const getCompanyColumns = (props) => { 
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
    };
    const formatChars={ 
      "U": "[A-Z]", 
      "A": "[A-Z0-9]", 
      "a": "[A-Za-z0-9]",
      "9": "[0-9]",
      "D": "[0-9.]",
      "-": "-",
      "x": "."
    }
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...(ColumnWidth(200)),
        cellStyle: { padding: "8px 2px 8px 12px" },
        headerStyle: { padding: "8px 2px 8px 12px" },
        title: "Code",
        field: "companyCode",
        initialEditValue: "",
        editable: props.canEdit ? "onAdd" : "never",
        editComponent: (props) => (
          <MaskedText
            mask="UUUUUUUU"
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            forceUpperCase={true}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
      {
        ...baseColumn,
        title: "Name",
        field: "companyName",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(50)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
      // {
      //   ...baseColumn,
      //   title: "Exchange Rate Provider",
      //   field: "exchangeRateType",
      //   editComponent: (props) => (
      //     <ExchangeRateProviderSelector
      //       type="FUEL"
      //       value={props.value}
      //       onChange={props.onChange}
      //       includeOther={true}
      //     />
      //   )
      // },
      // {
      //   ...baseColumn,
      //   title: "Default Currency",
      //   field: "defaultCurrencyCode",
      //   editComponent: (props) => (
      //     <CurrencySelector
      //       queryClient= { props.queryClient }
      //       value={props.value}
      //       onChange={props.onChange}
      //     />
      //   )
      // },
      // {
      //   ...baseColumn,
      //   title: "Contract Type",
      //   field: "contractType",
      //   editable: props.canEdit ? "always" : "never",
      //   initialEditValue: contractTypes[0],
      //   editComponent: (props) => (
      //     <Select
      //       labelId="Contract Type"
      //       id="Contract Type"
      //       value={props.value}
      //       onChange={e => {
      //         props.onChange(e.target.value);
      //       }}
      //     >
      //       {contractTypes.map((item) => {
      //         return (<MenuItem key={item} value={item}>{item}</MenuItem>);
      //       })
      //       }
      //     </Select>
      //   ),
      //   render: (rowData) => (<div>{rowData.contractType}</div>),
      // },
      // {
      //   ...baseColumn,
      //   title: "Price Period",
      //   field: "pricePeriod",
      //   editable: props.canEdit ? "always" : "never",
      //   initialEditValue: pricePeriods[0],
      //   editComponent: (props) => (
      //     <Select
      //       labelId="Price Period"
      //       id="Price Period"
      //       value={props.value}
      //       onChange={e => {
      //         props.onChange(e.target.value);
      //       }}
      //     >
      //       {pricePeriods.map((item) => {
      //         return (<MenuItem key={item} value={item}>{item}</MenuItem>);
      //       })
      //       }
      //     </Select>
      //   ),
      //   render: (rowData) => (<div>{rowData.pricePeriod}</div>),
      // },
    ];
  };
  
  return (isAuthenticated &&
      <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
        <MaterialTable
            tableRef={tableRef}
            style={{
              border: "none",
              boxShadow: "none",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.tableHeader.backgroundColor,
                color: theme.palette.tableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              pageSize: 10,
              detailPanelType: "single",
            }}
            actions={[
              {
                hidden: false,
                icon: 'save_alt',
                iconProps: { style: { color: theme.palette.primary.main } },
                tooltip: 'Export to Excel',
                isFreeAction: true,
                onClick: () => { downloadFuelSuppliers() }
              }
            ]}
            components={{
              ...defaultComponents,
              Pagination: (props) => (
                  <TablePagination
                      {...props}
                      rowsPerPageOptions={[5, 10, 15]}
                  />
              ),
            }}
            title="Fuel Suppliers"
            columns={getCompanyColumns({canEdit: state.canEdit})}
            detailPanel={
              [
                {
                  tooltip: "Show Fuel Details",
                  render: (rowData) => {
                    return (
                      <div>
                        <div style={{ backgroundColor: "#f2f2f2" }}>
                          <FuelSupplierAirportList
                            canEdit={state.canEdit}
                            record={rowData}
                          />
                        </div>
                      </div>
                    );
                  },
                },
              ]
            }
            data={companies.data}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    handleAddCompany.mutate({ record: { ...newData, isFuelSupplier: true }, resolve, reject, extraKeys});
                  })
                  : undefined,
              onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    handleUpdateCompany.mutate({record: newData, oldRecord: oldData, resolve, reject, extraKeys});
                  }),
              onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    handleDeleteCompany.mutate({oldRecord: oldData, resolve, reject, extraKeys});
                  }),
            }}
        />
      </div>
  );

}

export default FuelSupplierList;
